<template>
    <div class="component-chkeckbox-standard">
        <div class="mdc-form-field">
            <div class="mdc-checkbox">
                <input
                    type="checkbox"
                    class="mdc-checkbox__native-control"
                    :id="config.id"
                    :disabled="disabled"
                    :checked="config.checked"
                />
                <div class="mdc-checkbox__background">
                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59" />
                    </svg>
                    <div class="mdc-checkbox__mixedmark"></div>
                </div>
                <div class="mdc-checkbox__ripple"></div>
            </div>
            <label class="label_value" for="checkbox-1">
                <div class="div_label_checkbox">{{ config.value }}</div>
                <div class="div2_label_checkbox">{{ config.value2 }}</div>
            </label>
        </div>
    </div>
</template>

<script>
/**
 * Standard component Checkbox
 *
 * @param {Object} config         Prop responsável por iniciar o objeto corretamente
 * @param {type}   config.checked Responsavel por marcar e desmarcar o component
 * @param {type}   config.value   Seta o label do componente
 * @param {type}   config.value2   Seta uma segunda label do componente
 */
export default {
    props: {
        config: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    methods: {},
    disabled: {
        type: Boolean
    }
};
</script>

<style lang="scss">
@import '@sass/_variables.scss';
@import '@sass/components.scss';

.component-chkeckbox-standard {
    display: flex;
    align-content: center;

    .mdc-form-field {
        .mdc-checkbox {
            pointer-events: none;
            flex: 0 0 24px !important;
            width: 24px !important;
            height: 24px !important;

            .mdc-checkbox__background::before {
                top: -10px;
                left: -10px;
                width: 40px;
                height: 40px;
            }
        }
    }

    .mdc-checkbox__background {
        border-color: var(--v-primary-base) !important;
        background-color: transparent !important;
        width: 24px;
        height: 24px;
        border: 2px solid currentColor;
        border-radius: 4px;
    }

    .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
        color: var(--v-primary-base) !important;
    }

    .mdc-form-field {
        cursor: pointer;

        label {
            display: block;
            margin: 0;
            cursor: pointer;
        }

        .label_value {
            display: flex;

            .div_label_checkbox {
                margin-right: 5px;
            }
        }
    }
}
</style>
